import { render, staticRenderFns } from "./activityOrdinary.vue?vue&type=template&id=c4353aaa&scoped=true&"
import script from "./activityOrdinary.vue?vue&type=script&lang=js&"
export * from "./activityOrdinary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4353aaa",
  null
  
)

export default component.exports